import type React from "react";
import { Group, Stack, Text } from "@mantine/core";
import { Badge, Card } from "@xplatform/design-system";
import { IconSparkles } from "@tabler/icons-react";
import type { SearchHit } from "@models/search";
import MetadataGrid from "./MetadataGrid";

function similarityColor(pct: number): string {
  if (pct >= 70) return "teal";
  if (pct >= 50) return "brand";
  return "gray";
}

interface ResultCardProps {
  hit: SearchHit;
}

const ResultCard: React.FC<ResultCardProps> = ({ hit }) => {
  const meta = hit.metadata ?? {};
  const pct = Math.round(hit.similarity * 100);

  return (
    <Card withBorder radius="md" padding="lg" shadow="xs">
      <Stack gap="md">
        <Group justify="space-between" wrap="nowrap" align="flex-start">
          <Stack gap={6}>
            <Text fw={600}>{hit.title}</Text>
            {hit.sources && hit.sources.length > 0 && (
              <Group gap={6}>
                {hit.sources.map((source) => (
                  <Badge key={source} size="sm" variant="dot" color="brand">
                    {source}
                  </Badge>
                ))}
              </Group>
            )}
          </Stack>
          <Badge variant="light" color={similarityColor(pct)} size="lg">
            {pct}%
          </Badge>
        </Group>

        <MetadataGrid metadata={meta} omit={["text_hash"]} />

        {hit.reason && (
          <Group gap={6} wrap="nowrap" align="flex-start">
            <IconSparkles size={16} color="var(--mantine-color-brand-6)" />
            <Text size="sm" fs="italic" c="dimmed">
              {hit.reason}
            </Text>
          </Group>
        )}
      </Stack>
    </Card>
  );
};

export default ResultCard;
